import React from 'react';

import StripeAccount from './StripeAccount';
import StripeCallback from './StripeCallback';

const Account = ({
  match,
  ...other
}) => {
  return match.url.includes('/callback') ? (
    <StripeCallback {...other}/>
  ) : (
    <StripeAccount {...other}/>
  )
}

Account.propTypes = {

};

export default Account;
